<template>
  <v-autocomplete
    variant="outlined"
    density="compact"
    v-model="inputValue"
    v-bind:items="parStatuss"
    v-bind:item-title="(item) => objectTranslator(item, 'PAR_STATUS_NAME')"
    v-bind:item-value="(item) => item.PAR_STATUS_ID"
    v-bind:rules="rules"
  ></v-autocomplete>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

export default {
  name: "ParentStatusCard",
  props: {
    modelValue: String,
  },

  data: () => ({
    rules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    parStatuss: function () {
      return this.$store.state.ref.parStatuss;
    },

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getParStatuss");
  },
};
</script>
